import { apiSlice } from ".";

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotification: builder.query({
      query: (agentId) => ({
        url: `/NotificationsTables/GetNotificationsWithNames?receiverid=${agentId}&type=3`,
        method: "GET",
      }),
    }),
      readNotification: builder.mutation({
      query: (id) => ({
        url: `/NotificationsTables/UpdateReadStatus/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["notification"],
    }),
    getAllNotificationById: builder.query({
      query: (id) => ({
        url: `/NotificationsTables/NotificationsTables/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllNotificationQuery,  useReadNotificationMutation, useGetAllNotificationByIdQuery } =
  notificationApi;
